import {
  IFinancialGoalsResponse,
  IFinancialIndicatorsResponse,
  IUpdateGoalsPayload,
  IUpdateMonthlyPayload
} from '../../interfaces/IFinancialIndicators'
import apiService from '../Api'

export default class FinancialIndicatorsService {
  async getIndicators(
    startYear: number,
    startMonth: number,
    endYear: number,
    endMonth: number
  ): Promise<{ data: IFinancialIndicatorsResponse }> {
    return apiService.get('/financial-indicators', {
      params: {
        start_year: startYear,
        start_month: startMonth,
        end_year: endYear,
        end_month: endMonth
      }
    })
  }

  async getGoals(year: number): Promise<{ data: IFinancialGoalsResponse }> {
    return apiService.get('/financial-indicators/goals', {
      params: { year }
    })
  }

  async updateMonthlyData(payload: IUpdateMonthlyPayload) {
    return apiService.put('/financial-indicators/monthly', payload)
  }

  async updateGoals(payload: IUpdateGoalsPayload) {
    return apiService.put('/financial-indicators/goals', payload)
  }
}
